import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import axiosApi from "../../../../../../../core/interceptor/interceptor";
import { config } from "../../../../../../../config";
import getSearchParam from "../../../../../../../hooks/UrlSearchParam";
import "../../LeagueGroups/PlayOffBracket/PlayOffBracket.css"
import { TBD } from "../../../../../../../Util/helper";

function TheoreticalPlayoffBracket(props) {
  const [leagueId, setLeagueId] = useState(0);
  const [leagueData, setLeagueData] = useState({ teamData: [], leagueInfo: {} });
  const [roundData, setRoundData] = useState([]);
  const [finalRound, setFinalRound] = useState({});
  const [semiFinalRound, setSemiFinalRound] = useState({});
  const [locationField, setLocationField] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const leagueId_ = getSearchParam(props.location).get('leagueId');
    if (leagueId_ > 0) {
      setLeagueId(leagueId_);
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (leagueId > 0) {
      getPlayoffBracket();
    }
    //eslint-disable-next-line
  }, [leagueId]);

  const getPlayoffBracket = () => {
    axiosApi.get(`${config.apiUrl}/leagues/schedule/playoff/bracket/${leagueId}/false`)
      .then((response) => {
        setErrorMessage(response.data.message);
        if (response.data.status === 'success') {
          setLeagueData({
            teamData: response.data.teamData,
            leagueInfo: response.data.leagueInfo,
            leagueDivision: response.data.leagueDivision
          });
          const data = response.data && response.data.data && response.data.data.divisionData ? response.data.data.divisionData : [];
          data.forEach((division) => {
            if (division.bracketData) {
              division.bracketData.forEach((element, index) => {
                if (element.bracket) {
                  let keyIndex = 1;
                  if (element.bracket.length <= 2) {
                    const bracketElement = [...element.bracket.filter(br => br.key === 'winner')];
                    if (element.byes && +element.byes > 0) {
                      while (keyIndex <= +element.byes && keyIndex <= element.bracket.length) {
                        element['newBracket'] = {
                          ...element['newBracket'], ...{
                            [`key${keyIndex}`]: [...[bracketElement.shift()]].filter(item => item)
                          }
                        }
                        keyIndex++;
                      }
                    }
                    if (bracketElement.length) {
                      element['newBracket'] = {
                        ...element['newBracket'], ...{
                          [`key${keyIndex}`]: [...bracketElement].filter(item => item)
                        }
                      }
                    }
                    // handling 10 team case
                    if (+element.byes === 6) {
                      const tempKey2 = element['newBracket'].key2;
                      element['newBracket'] = {
                        ...element['newBracket'],
                        ...{ key2: [], key3: [...tempKey2] }
                      }
                    }
                  } else {
                    const bracketElement = [...element.bracket.filter(br => br.key === 'winner')];
                    const lBracketElement = [...element.bracket.filter(br => br.key === 'looser')];
                    // adding new checks

                    let modifiedBracket = [];
                    if (element.byes && +element.byes > 0) {
                      while (keyIndex <= +element.byes && keyIndex <= element.bracket.length) {
                        if ((element.byes === 3 || element.byes === 2 )&& element.bracketSize === 16) {
                          if (keyIndex > 1) {
                            modifiedBracket = [...[bracketElement.pop()], ...modifiedBracket];
                          } else {
                            element['newBracket'] = {
                              ...element['newBracket'], ...{
                                [`key${keyIndex}`]: [...[bracketElement.shift()]].filter(item => item)
                              }
                            }
                          }
                        } else {
                          element['newBracket'] = {
                            ...element['newBracket'], ...{
                              [`key${keyIndex}`]: [...[bracketElement.shift()]].filter(item => item)
                            }
                          }
                        }
                        keyIndex++;
                      }
                    }

                    do {
                      if (bracketElement.length) {
                        if (!index) {
                          if ((element.byes === 2 || element.byes === 1) && element.bracketSize === 16) {
                            element['newBracket'] = {
                              ...element['newBracket'], ...{
                                [`key${keyIndex}`]: [...[bracketElement.shift()], ...[bracketElement.shift()]].filter(item => item)
                              }
                            }
                          } else {
                            element['newBracket'] = {
                              ...element['newBracket'], ...{
                                [`key${keyIndex}`]: [...[bracketElement.shift()], ...[bracketElement.pop()]].filter(item => item)
                              }
                            }
                          }
                        } else {
                          element['newBracket'] = {
                            ...element['newBracket'], ...{
                              [`key${keyIndex}`]: [...[bracketElement.shift()], ...[bracketElement.shift()]].filter(item => item)
                            }
                          }
                        }
                        keyIndex++;
                      }
                    } while (bracketElement.length > 0)

                    // adding some more extra checks
                    while (modifiedBracket.length > 0) {
                      element['newBracket'] = {
                        ...element['newBracket'], ...{
                          [`key${keyIndex}`]: [...[modifiedBracket.shift()]].filter(item => item)
                        }
                      }
                      keyIndex++;
                    }

                    // looser
                    do {
                      if (lBracketElement.length) {
                        if (!index) {
                          element['newBracket'] = {
                            ...element['newBracket'], ...{
                              [`key${keyIndex}`]: [...[lBracketElement.shift()], ...[lBracketElement.pop()]].filter(item => item)
                            }
                          }
                        } else {
                          element['newBracket'] = {
                            ...element['newBracket'], ...{
                              [`key${keyIndex}`]: [...[lBracketElement.shift()], ...[lBracketElement.shift()]].filter(item => item)
                            }
                          }
                        }
                        keyIndex++;
                      }
                    } while (lBracketElement.length > 0)

                    // handling 11 team case
                    if (+element.byes === 5) {
                      const tempKey2 = element['newBracket'].key2;
                      const tempKey3 = element['newBracket'].key3;
                      element['newBracket'] = {
                        ...element['newBracket'],
                        ...{ key2: [], key3: [...tempKey2], key4: [...tempKey3] }
                      }
                    }

                    if (element.round > 1) {
                      element['newBracket'] = Object.fromEntries(Object.entries(element['newBracket']).filter(([_, v]) => v && v.length));
                    }
                  }
                }
              });
            }
          });
          setRoundData(data);
          setFinalRound(response.data.data && response.data.data.final ? response.data.data.final : []);
          setSemiFinalRound(response.data.data && response.data.data.semiFinal ? response.data.data.semiFinal : []);
          setLocationField(response.data && response.data.data && response.data.data.locations ? response.data.data.locations : [])
        }
      })
  }

  // const teamName = (id) => {
  //   let name = '--';
  //   if (id && leagueData && leagueData.teamData) {
  //     name = leagueData.teamData.find(x => +x.id === +id) ? leagueData.teamData.find(x => +x.id === +id).name : '--';
  //   }
  //   return name;
  // }

  const teamName = (id) => {
    let name = '--';
    if (id && leagueData && leagueData.teamData) {
      if (leagueData && leagueData.leagueDivision && leagueData.leagueDivision.length) {
        let found = false;
        for (const division of leagueData.leagueDivision) {
          const teamIds = division.team_ids.split(',').map((id) => +id);
          if (teamIds && teamIds.length) {
            const filterTeam = leagueData.teamData.filter(x => teamIds.includes(x.id));
            if (filterTeam && filterTeam.length) {
              const findTeam = filterTeam.find(x => +x.id === +id);
              if (findTeam) {
                name = divisionTeamName(filterTeam, id);
                found = true;
                break;
              }
            }
          }
        }
        if (!found) {
          name = divisionTeamName(leagueData.teamData, id);
        }
      } else {
        name = divisionTeamName(leagueData.teamData, id);
      }
    }
    return name;
  }

  const divisionTeamName = (teamData, id) => {
    let name = '';
    const findTeam = teamData.find(x => +x.id === +id);
    if (findTeam) {
      const teamIndex = teamData.indexOf(findTeam);
      name = 'TBD';
      if (findTeam.score || findTeam.score === 0) {
        name = `${teamIndex + 1} ${findTeam.name}`;
      }
    }
    return name;
  }

  const locationName = (id) => {
    let name = '';
    if (id && locationField) {
      name = locationField.find(x => +x.location_id === +id) ? locationField.find(x => +x.location_id === +id).location_name : '';
    }
    return name;
  }

  const fieldName = (id) => {
    let name = '';
    if (id && locationField) {
      const fields = [].concat.apply([], locationField.map(x => x.fields));
      name = fields.find(x => +x.field_id === +id) ? fields.find(x => +x.field_id === +id).field_name : '';
    }
    return name;
  }

  return (
    <>
      {
        leagueData &&
        leagueData.leagueInfo &&
        roundData.length > 0 &&
        <div className="playoff-bracket schedule-create-block">
          <h2>Theoretical Playoff Bracket</h2>
          <p>Elimination Type - {leagueData.leagueInfo?.elimination_type}</p>
          <div className={`outer-wrapper ${roundData.length === 3 ? 'final-3' : `${roundData.length === 2 ? 'final-2' : ''}`} ${leagueData.leagueInfo?.elimination_type === 'Double Elimination' ? 'double-bracket-block' : ''}`}>
            <div className="inner-wrapper">
              <div className="leftBrackets-blk">
                {
                  roundData.length > 0 &&
                  roundData[0] &&
                  roundData[0].bracketData.length > 0 &&
                  roundData[0].bracketData.map((roundD, i) => (
                    <>
                      {
                        (i !== roundData[0].bracketData.length - 1) ?
                          <div className={`col-blk level-${i + 1}`} key={`${roundD.round}_${i}`}>
                            {
                              roundD.newBracket &&
                              Object.keys(roundD.newBracket).map((key, index) => (
                                <div className={`inner-blk  ${roundD.newBracket[key].length === 1 ? 'single-blk single-cell' : `${!roundD.newBracket[key].length ? 'empty-cell' : ''}`}`} key={`${key}-${index}`}>
                                  {
                                    roundD.newBracket[key].map((bracketD) => (
                                      <div className={`content-blk ${i && (bracketD.schedule.note1 || bracketD.schedule.note2) ? 'before' : ''}`} key={bracketD.name}>
                                        <div className="date-blk">
                                          <span className="date">{bracketD?.date}</span>
                                          <span className="time">{TBD.value.includes(bracketD?.time) ? TBD.name : bracketD?.time}</span>
                                        </div>
                                        <div className="name-blk">
                                          <div className="row">
                                            {
                                              bracketD?.schedule &&
                                              ((e) => {
                                                if (e.team1_id) {
                                                  return <div className="name">
                                                    <span>{teamName(e.team1_id)}</span>
                                                  </div>
                                                } else {
                                                  return <div className="name">
                                                    <span>{e.note1 ? e.note1 : '--'}</span>
                                                  </div>
                                                }
                                              })(bracketD.schedule)
                                            }
                                            <div className="grey-blk"></div>
                                          </div>
                                          <div className="row">
                                            {
                                              bracketD?.schedule &&
                                              ((e) => {
                                                if (e.team2_id) {
                                                  return <div className="name">
                                                    <span>{teamName(e.team2_id)}</span>
                                                  </div>
                                                } else {
                                                  return <div className="name">
                                                    <span>{e.note2 ? e.note2 : '--'}</span>
                                                  </div>
                                                }
                                              })(bracketD.schedule)
                                            }
                                            <div className="grey-blk"></div>
                                          </div>
                                        </div>
                                        <div className="team-name">
                                          <span>{bracketD?.name} - {bracketD?.field_id ? fieldName(bracketD?.field_id) : TBD.name} - {locationName(bracketD?.location_id)}</span>
                                        </div>
                                      </div>
                                    ))
                                  }
                                </div>
                              ))
                            }
                          </div>
                          :
                          <div className={`col-blk level-${((i === 1 || i === 2) && Object.keys(roundD.newBracket).length === 1) ? `${i}` : `${i + 1}`}`} key={`${roundD.round}_${i}`}>
                            {
                              roundD.newBracket &&
                              Object.keys(roundD.newBracket).map((key, index) => (
                                <div className={`inner-blk no-after  ${roundD.newBracket[key].length === 1 ? 'single-blk final-blk' : ''}`} key={`${key}-${index}-${roundD.round}`}>
                                  {
                                    roundD.newBracket[key].map((last) => (
                                      <>
                                        {
                                          roundData.length === 1 &&
                                          <span className="left-final">Final</span>
                                        }
                                        <div className={`content-blk before ${roundData.length > 1 ? 'after' : 'no-after'}`} key={last.name}>
                                          <div className="date-blk">
                                            <span className="date">{last?.date}</span>
                                            <span className="time">{TBD.value.includes(last?.time) ? TBD.name : last?.time}</span>
                                          </div>
                                          <div className="name-blk">
                                            <div className="row">
                                              {
                                                last?.schedule &&
                                                ((e) => {
                                                  if (e.team1_id) {
                                                    return <div className="name">
                                                      <span>{teamName(e.team1_id)}</span>
                                                    </div>
                                                  } else {
                                                    return <div className="name">
                                                      <span>{e.note1 ? e.note1 : '--'}</span>
                                                    </div>
                                                  }
                                                })(last.schedule)
                                              }
                                              <div className="grey-blk"></div>
                                            </div>
                                            <div className="row">
                                              {
                                                last?.schedule &&
                                                ((e) => {
                                                  if (e.team2_id) {
                                                    return <div className="name">
                                                      <span>{teamName(e.team2_id)}</span>
                                                    </div>
                                                  } else {
                                                    return <div className="name">
                                                      <span>{e.note2 ? e.note2 : '--'}</span>
                                                    </div>
                                                  }
                                                })(last.schedule)
                                              }
                                              <div className="grey-blk"></div>
                                            </div>
                                          </div>
                                          <div className="team-name">
                                            <span>{last?.name} - {last?.field_id ? fieldName(last?.field_id) : TBD.name} - {locationName(last?.location_id)}</span>
                                          </div>
                                        </div>
                                      </>
                                    ))
                                  }
                                </div>
                              ))
                            }
                          </div>
                      }
                    </>
                  ))
                }

              </div>

              {
                roundData &&
                roundData.length > 1 &&
                finalRound.length > 0 &&
                <div className="champion-blk">
                  {
                    roundData.length === 2 &&
                    <div className="semiFinal-wrapper">
                      {
                        finalRound.map((finalP, index) => (
                          <div className="Final-blk-wrapper" key={`${finalP.roundD}-${index}`}>
                            <span>
                              Final</span>
                            {
                              finalP.bracket &&
                              finalP.bracket.map((finalC, i) => (
                                <div className="content-blk no-after" key={`${finalC.name}-${i}`}>
                                  <div className="date-blk">
                                    <span className="date">{finalC?.date}</span>
                                    <span className="time">{TBD.value.includes(finalC?.time) ? TBD.name : finalC?.time}</span>
                                  </div>
                                  <div className="name-blk">
                                    <div className="row">
                                      {
                                        finalC?.schedule &&
                                        ((e) => {
                                          if (e.team1_id) {
                                            return <div className="name">
                                              <span>{teamName(e.team1_id)}</span>
                                            </div>
                                          } else {
                                            return <div className="name">
                                              <span>{e.note1 ? e.note1 : '--'}</span>
                                            </div>
                                          }
                                        })(finalC.schedule)
                                      }
                                      <div className="grey-blk"></div>
                                    </div>
                                    <div className="row">
                                      {
                                        finalC?.schedule &&
                                        ((e) => {
                                          if (e.team2_id) {
                                            return <div className="name">
                                              <span>{teamName(e.team2_id)}</span>
                                            </div>
                                          } else {
                                            return <div className="name">
                                              <span>{e.note2 ? e.note2 : '--'}</span>
                                            </div>
                                          }
                                        })(finalC.schedule)
                                      }
                                      <div className="grey-blk"></div>
                                    </div>
                                  </div>
                                  <div className="team-name">
                                    <span>{finalC?.name} - {finalC?.field_id ? fieldName(finalC?.field_id) : TBD.name} - {locationName(finalC?.location_id)}</span>
                                  </div>
                                </div>
                              ))
                            }
                          </div>
                        ))
                      }
                    </div>
                  }
                </div>
              }

              {
                roundData.length > 0 &&
                roundData[1] &&
                <div className="rightBrackets-blk">
                  {
                    roundData[1].bracketData.length > 0 &&
                    roundData[1].bracketData.slice(0).reverse().map((roundD, i) => (
                      (i !== 0) ?
                        <div className={`col-blk level-${roundData[1].bracketData.length - i}`} key={`${roundData[1].name}-${roundD.round}`}>
                          {
                            roundD.newBracket &&
                            Object.keys(roundD.newBracket).map((key, index) => (
                              <div className={`inner-blk  ${roundD.newBracket[key].length === 1 ? 'single-blk single-cell' : `${!roundD.newBracket[key].length ? 'empty-cell' : ''}`}`} key={`${key}-${index}`}>
                                {
                                  roundD.newBracket[key].map((bracketD) => (
                                    <div className={`content-blk ${i && (bracketD.schedule.note1 || bracketD.schedule.note2) ? 'after' : ''}`} key={bracketD.name}>
                                      <div className="date-blk">
                                        <span className="date">{bracketD?.date}</span>
                                        <span className="time">{TBD.value.includes(bracketD?.time) ? TBD.name : bracketD?.time}</span>
                                      </div>
                                      <div className="name-blk">
                                        <div className="row">
                                          {
                                            bracketD?.schedule &&
                                            ((e) => {
                                              if (e.team1_id) {
                                                return <div className="name">
                                                  <span>{teamName(e.team1_id)}</span>
                                                </div>
                                              } else {
                                                return <div className="name">
                                                  <span>{e.note1 ? e.note1 : '--'}</span>
                                                </div>
                                              }
                                            })(bracketD.schedule)
                                          }
                                          <div className="grey-blk"></div>
                                        </div>
                                        <div className="row">
                                          {
                                            bracketD?.schedule &&
                                            ((e) => {
                                              if (e.team2_id) {
                                                return <div className="name">
                                                  <span>{teamName(e.team2_id)}</span>
                                                </div>
                                              } else {
                                                return <div className="name">
                                                  <span>{e.note2 ? e.note2 : '--'}</span>
                                                </div>
                                              }
                                            })(bracketD.schedule)
                                          }
                                          <div className="grey-blk"></div>
                                        </div>
                                      </div>
                                      <div className="team-name">
                                        <span>{bracketD?.name} - {bracketD?.field_id ? fieldName(bracketD?.field_id) : TBD.name} - {locationName(bracketD?.location_id)}</span>
                                      </div>
                                    </div>
                                  ))
                                }
                              </div>
                            ))
                          }
                        </div>
                        :
                        <div className={`col-blk level-${Object.keys(roundD.newBracket).length === 1 && roundData[1].bracketData.length === 3 ? `${roundData[1].bracketData.length - i - 1} champion-before` : `${roundData[1].bracketData.length - i}`}`} key={`${roundD.round}_${i}`}>
                          {
                            roundD.newBracket &&
                            Object.keys(roundD.newBracket).map((key, index) => (
                              <div className={`inner-blk no-before ${roundD.newBracket[key].length === 1 ? 'single-blk' : ''}`} key={`${key}-${index}-${roundD.round}`}>
                                {
                                  roundD.newBracket[key].map((last) => (
                                    <div className="content-blk after no-before" key={last.name}>
                                      <div className="date-blk">
                                        <span className="date">{last?.date}</span>
                                        <span className="time">{TBD.value.includes(last?.time) ? TBD.name : last?.time}</span>
                                      </div>
                                      <div className="name-blk">
                                        <div className="row">
                                          {
                                            last?.schedule &&
                                            ((e) => {
                                              if (e.team1_id) {
                                                return <div className="name">
                                                  <span>{teamName(e.team1_id)}</span>
                                                </div>
                                              } else {
                                                return <div className="name">
                                                  <span>{e.note1 ? e.note1 : '--'}</span>
                                                </div>
                                              }
                                            })(last.schedule)
                                          }
                                          <div className="grey-blk"></div>
                                        </div>
                                        <div className="row">
                                          {
                                            last?.schedule &&
                                            ((e) => {
                                              if (e.team2_id) {
                                                return <div className="name">
                                                  <span>{teamName(e.team2_id)}</span>
                                                </div>
                                              } else {
                                                return <div className="name">
                                                  <span>{e.note2 ? e.note2 : '--'}</span>
                                                </div>
                                              }
                                            })(last.schedule)
                                          }
                                          <div className="grey-blk"></div>
                                        </div>
                                      </div>
                                      <div className="team-name">
                                        <span>{last?.name} - {last?.field_id ? fieldName(last?.field_id) : TBD.name} - {locationName(last?.location_id)}</span>
                                      </div>
                                    </div>
                                  ))
                                }
                              </div>
                            ))
                          }
                        </div>
                    ))
                  }
                </div>
              }
            </div>

            {
              roundData &&
              roundData.length > 1 &&
              finalRound.length > 0 &&
              roundData.length !== 2 &&
              <div className={`semiFinal-wrapper ${roundData.length === 3? 'three-division' : `${roundData.length === 4 ? 'four-division': ''}`}`}>
                {
                  semiFinalRound.length > 0 &&
                  semiFinalRound[0] &&
                  semiFinalRound.map((semiF, index) => (
                    <div className="semiFinal-blk-wrapper" key={`${semiF.roundD}-${index}`}>
                      <span>Semifinal</span>
                      {
                        semiF.bracket &&
                        semiF.bracket[0] &&
                        <div className="semiFinal-blk">
                          <div className="content-blk no-after">
                            <div className="date-blk">
                              <span className="date">{semiF.bracket[0]?.date}</span>
                              <span className="time">{TBD.value.includes(semiF.bracket[0]?.time) ? TBD.name : semiF.bracket[0]?.time}</span>
                            </div>
                            <div className="name-blk">
                              <div className="row">
                                {
                                  semiF.bracket[0]?.schedule &&
                                  ((e) => {
                                    if (e.team1_id) {
                                      return <div className="name">
                                        <span>{teamName(e.team1_id)}</span>
                                      </div>
                                    } else {
                                      return <div className="name">
                                        <span>{e.note1 ? e.note1 : '--'}</span>
                                      </div>
                                    }
                                  })(semiF.bracket[0].schedule)
                                }
                                <div className="grey-blk"></div>
                              </div>
                              <div className="row">
                                {
                                  semiF.bracket[0]?.schedule &&
                                  ((e) => {
                                    if (e.team2_id) {
                                      return <div className="name">
                                        <span>{teamName(e.team2_id)}</span>
                                      </div>
                                    } else {
                                      return <div className="name">
                                        <span>{e.note2 ? e.note2 : '--'}</span>
                                      </div>
                                    }
                                  })(semiF.bracket[0].schedule)
                                }
                                <div className="grey-blk"></div>
                              </div>
                            </div>
                            <div className="team-name">
                              <span>{semiF.bracket[0]?.name} - {semiF.bracket[0]?.field_id ? fieldName(semiF.bracket[0]?.field_id) : TBD.name} - {locationName(semiF.bracket[0]?.location_id)}</span>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  ))
                }

                {
                  finalRound.map((finalP, index) => (
                    <div className="Final-blk-wrapper" key={`${finalP.roundD}-${index}`}>
                      <span>
                        Final</span>
                      {
                        finalP.bracket &&
                        finalP.bracket.map((finalC, i) => (
                          <div className="content-blk no-after" key={`${finalC.name}-${i}`}>
                            <div className="date-blk">
                              <span className="date">{finalC?.date}</span>
                              <span className="time">{TBD.value.includes(finalC?.time) ? TBD.name : finalC?.time}</span>
                            </div>
                            <div className="name-blk">
                              <div className="row">
                                {
                                  finalC?.schedule &&
                                  ((e) => {
                                    if (e.team1_id) {
                                      return <div className="name">
                                        <span>{teamName(e.team1_id)}</span>
                                      </div>
                                    } else {
                                      return <div className="name">
                                        <span>{e.note1 ? e.note1 : '--'}</span>
                                      </div>
                                    }
                                  })(finalC.schedule)
                                }
                                <div className="grey-blk"></div>
                              </div>
                              <div className="row">
                                {
                                  finalC?.schedule &&
                                  ((e) => {
                                    if (e.team2_id) {
                                      return <div className="name">
                                        <span>{teamName(e.team2_id)}</span>
                                      </div>
                                    } else {
                                      return <div className="name">
                                        <span>{e.note2 ? e.note2 : '--'}</span>
                                      </div>
                                    }
                                  })(finalC.schedule)
                                }
                                <div className="grey-blk"></div>
                              </div>
                            </div>
                            <div className="team-name">
                              <span>{finalC?.name} - {finalC?.field_id ? fieldName(finalC?.field_id) : TBD.name} - {locationName(finalC?.location_id)}</span>
                            </div>
                          </div>
                        ))
                      }
                    </div>
                  ))
                }

                {
                  semiFinalRound.length > 0 &&
                  semiFinalRound[0] &&
                  semiFinalRound[0].bracket.length > 1 &&
                  semiFinalRound.map((semiF, index) => (
                    <div className="semiFinal-blk-wrapper" key={`${semiF.roundD}-${index}`}>
                      <span>Semifinal</span>
                      {
                        semiF.bracket &&
                        semiF.bracket[1] &&
                        <div className="content-blk no-after">
                          <div className="date-blk">
                            <span className="date">{semiF.bracket[1]?.date}</span>
                            <span className="time">{TBD.value.includes(semiF.bracket[1]?.time) ? TBD.name : semiF.bracket[1]?.time}</span>
                          </div>
                          <div className="name-blk">
                            <div className="row">
                              {
                                semiF.bracket[1]?.schedule &&
                                ((e) => {
                                  if (e.team1_id) {
                                    return <div className="name">
                                      <span>{teamName(e.team1_id)}</span>
                                    </div>
                                  } else {
                                    return <div className="name">
                                      <span>{e.note1 ? e.note1 : '--'}</span>
                                    </div>
                                  }
                                })(semiF.bracket[1].schedule)
                              }
                              <div className="grey-blk"></div>
                            </div>
                            <div className="row">
                              {
                                semiF.bracket[1]?.schedule &&
                                ((e) => {
                                  if (e.team2_id) {
                                    return <div className="name">
                                      <span>{teamName(e.team2_id)}</span>
                                    </div>
                                  } else {
                                    return <div className="name">
                                      <span>{e.note2 ? e.note2 : '--'}</span>
                                    </div>
                                  }
                                })(semiF.bracket[1].schedule)
                              }
                              <div className="grey-blk"></div>
                            </div>
                          </div>
                          <div className="team-name">
                            <span>{semiF.bracket[1]?.name} - {semiF.bracket[1]?.field_id ? fieldName(semiF.bracket[1]?.field_id) : TBD.name} - {locationName(semiF.bracket[1]?.location_id)}</span>
                          </div>
                        </div>
                      }
                    </div>
                  ))
                }
              </div>
            }

            <div className="inner-wrapper inner-wrapper-bottom">
              <div className="leftBrackets-blk">
                {
                  roundData.length > 0 &&
                  roundData[2] &&
                  roundData[2].bracketData.length > 0 &&
                  roundData[2].bracketData.map((roundD, i) => (
                    <>
                      {
                        (i !== roundData[0].bracketData.length - 1) ?
                          <div className={`col-blk level-${i + 1}`} key={`${roundD.round}_${i}`}>
                            {
                              roundD.newBracket &&
                              Object.keys(roundD.newBracket).map((key, index) => (
                                <div className={`inner-blk  ${roundD.newBracket[key].length === 1 ? 'single-blk single-cell' : `${!roundD.newBracket[key].length ? 'empty-cell' : ''}`}`} key={`${key}-${index}`}>
                                  {
                                    roundD.newBracket[key].map((bracketD) => (
                                      <div className={`content-blk ${i && (bracketD.schedule.note1 || bracketD.schedule.note2) ? 'before' : ''}`} key={bracketD.name}>
                                        <div className="date-blk">
                                          <span className="date">{bracketD?.date}</span>
                                          <span className="time">{TBD.value.includes(bracketD?.time) ? TBD.name : bracketD?.time}</span>
                                        </div>
                                        <div className="name-blk">
                                          <div className="row">
                                            {
                                              bracketD?.schedule &&
                                              ((e) => {
                                                if (e.team1_id) {
                                                  return <div className="name">
                                                    <span>{teamName(e.team1_id)}</span>
                                                  </div>
                                                } else {
                                                  return <div className="name">
                                                    <span>{e.note1 ? e.note1 : '--'}</span>
                                                  </div>
                                                }
                                              })(bracketD.schedule)
                                            }
                                            <div className="grey-blk">{bracketD?.schedule?.team1_score || (bracketD?.schedule?.team2_score ? 0 : '')}</div>
                                          </div>
                                          <div className="row">
                                            {
                                              bracketD?.schedule &&
                                              ((e) => {
                                                if (e.team2_id) {
                                                  return <div className="name">
                                                    <span>{teamName(e.team2_id)}</span>
                                                  </div>
                                                } else {
                                                  return <div className="name">
                                                    <span>{e.note2 ? e.note2 : '--'}</span>
                                                  </div>
                                                }
                                              })(bracketD.schedule)
                                            }
                                            <div className="grey-blk">{bracketD?.schedule?.team2_score || (bracketD?.schedule?.team1_score ? 0 : '')}</div>
                                          </div>
                                        </div>
                                        <div className="team-name">
                                          <span>{bracketD?.name} - {bracketD?.field_id ? fieldName(bracketD?.field_id) : TBD.name} - {locationName(bracketD?.location_id)}</span>
                                        </div>
                                      </div>
                                    ))
                                  }
                                </div>
                              ))
                            }
                          </div>
                          :
                          <div className={`col-blk level-${i + 1}`} key={`${roundD.round}_${i}`}>
                            {
                              roundD.newBracket &&
                              Object.keys(roundD.newBracket).map((key, index) => (
                                <div className={`inner-blk no-after ${roundD.newBracket[key].length === 1 ? 'single-blk' : ''}`} key={`${key}-${index}-${roundD.round}`}>
                                  {
                                    roundD.newBracket[key].map((last) => (
                                      <div className={`content-blk before`} key={last.name}>
                                        <div className="date-blk">
                                          <span className="date">{last?.date}</span>
                                          <span className="time">{TBD.value.includes(last?.time) ? TBD.name : last?.time}</span>
                                        </div>
                                        <div className="name-blk">
                                          <div className="row">
                                            {
                                              last?.schedule &&
                                              ((e) => {
                                                if (e.team1_id) {
                                                  return <div className="name">
                                                    <span>{teamName(e.team1_id)}</span>
                                                  </div>
                                                } else {
                                                  return <div className="name">
                                                    <span>{e.note1 ? e.note1 : '--'}</span>
                                                  </div>
                                                }
                                              })(last.schedule)
                                            }
                                            <div className="grey-blk">{last?.schedule?.team1_score || (last?.schedule?.team2_score ? 0 : '')}</div>
                                          </div>
                                          <div className="row">
                                            {
                                              last?.schedule &&
                                              ((e) => {
                                                if (e.team2_id) {
                                                  return <div className="name">
                                                    <span>{teamName(e.team2_id)}</span>
                                                  </div>
                                                } else {
                                                  return <div className="name">
                                                    <span>{e.note2 ? e.note2 : '--'}</span>
                                                  </div>
                                                }
                                              })(last.schedule)
                                            }
                                            <div className="grey-blk">{last?.schedule?.team2_score || (last?.schedule?.team1_score ? 0 : '')}</div>
                                          </div>
                                        </div>
                                        <div className="team-name">
                                          <span>{last?.name} - {last?.field_id ? fieldName(last?.field_id) : TBD.name} - {locationName(last?.location_id)}</span>
                                        </div>
                                      </div>
                                    ))
                                  }
                                </div>
                              ))
                            }
                          </div>
                      }
                    </>
                  ))
                }

              </div>

              {
                roundData &&
                roundData.length > 2 &&
                finalRound.length > 0 &&
                <div className={`champion-blk ${roundData.length === 3 ? 'no-after' : ''}`}>
                </div>
              }

              {
                roundData.length > 0 &&
                roundData[3] &&
                <div className="rightBrackets-blk">
                  {
                    roundData[3].bracketData.length > 0 &&
                    roundData[3].bracketData.slice(0).reverse().map((roundD, i) => (
                      (i !== 0) ?
                        <div className={`col-blk level-${roundData[1].bracketData.length - i}`} key={`${roundData[1].name}-${roundD.round}`}>
                          {
                            roundD.newBracket &&
                            Object.keys(roundD.newBracket).map((key, index) => (
                              <div className={`inner-blk  ${roundD.newBracket[key].length === 1 ? 'single-blk single-cell' : `${!roundD.newBracket[key].length ? 'empty-cell' : ''}`}`} key={`${key}-${index}`}>
                                {
                                  roundD.newBracket[key].map((bracketD) => (
                                    <div className={`content-blk ${i && (bracketD.schedule.note1 || bracketD.schedule.note2) ? 'after' : ''}`} key={bracketD.name}>
                                      <div className="date-blk">
                                        <span className="date">{bracketD?.date}</span>
                                        <span className="time">{TBD.value.includes(bracketD?.time) ? TBD.name : bracketD?.time}</span>
                                      </div>
                                      <div className="name-blk">
                                        <div className="row">
                                          {
                                            bracketD?.schedule &&
                                            ((e) => {
                                              if (e.team1_id) {
                                                return <div className="name">
                                                  <span>{teamName(e.team1_id)}</span>
                                                </div>
                                              } else {
                                                return <div className="name">
                                                  <span>{e.note1 ? e.note1 : '--'}</span>
                                                </div>
                                              }
                                            })(bracketD.schedule)
                                          }
                                          <div className="grey-blk">{bracketD?.schedule?.team1_score || (bracketD?.schedule?.team2_score ? 0 : '')}</div>
                                        </div>
                                        <div className="row">
                                          {
                                            bracketD?.schedule &&
                                            ((e) => {
                                              if (e.team2_id) {
                                                return <div className="name">
                                                  <span>{teamName(e.team2_id)}</span>
                                                </div>
                                              } else {
                                                return <div className="name">
                                                  <span>{e.note2 ? e.note2 : '--'}</span>
                                                </div>
                                              }
                                            })(bracketD.schedule)
                                          }
                                          <div className="grey-blk">{bracketD?.schedule?.team2_score || (bracketD?.schedule?.team1_score ? 0 : '')}</div>
                                        </div>
                                      </div>
                                      <div className="team-name">
                                        <span>{bracketD?.name} - {bracketD?.field_id ? fieldName(bracketD?.field_id) : TBD.name} - {locationName(bracketD?.location_id)}</span>
                                      </div>
                                    </div>
                                  ))
                                }
                              </div>
                            ))
                          }
                        </div>
                        :
                        <div className={`col-blk level-${roundData[1].bracketData.length - i}`} key={`${roundData[1].name}-${roundD.round}`}>
                          {
                            roundD.newBracket &&
                            Object.keys(roundD.newBracket).map((key, index) => (
                              <div className={`inner-blk no-before ${roundD.newBracket[key].length === 1 ? 'single-blk' : ''}`} key={`${key}-${index}-${roundD.round}`}>
                                {
                                  roundD.newBracket[key].map((last) => (
                                    <div className="content-blk after no-before" key={last.name}>
                                      <div className="date-blk">
                                        <span className="date">{last?.date}</span>
                                        <span className="time">{TBD.value.includes(last?.time) ? TBD.name : last?.time}</span>
                                      </div>
                                      <div className="name-blk">
                                        <div className="row">
                                          {
                                            last?.schedule &&
                                            ((e) => {
                                              if (e.team1_id) {
                                                return <div className="name">
                                                  <span>{teamName(e.team1_id)}</span>
                                                </div>
                                              } else {
                                                return <div className="name">
                                                  <span>{e.note1 ? e.note1 : '--'}</span>
                                                </div>
                                              }
                                            })(last.schedule)
                                          }
                                          <div className="grey-blk">{last?.schedule?.team1_score || (last?.schedule?.team2_score ? 0 : '')}</div>
                                        </div>
                                        <div className="row">
                                          {
                                            last?.schedule &&
                                            ((e) => {
                                              if (e.team2_id) {
                                                return <div className="name">
                                                  <span>{teamName(e.team2_id)}</span>
                                                </div>
                                              } else {
                                                return <div className="name">
                                                  <span>{e.note2 ? e.note2 : '--'}</span>
                                                </div>
                                              }
                                            })(last.schedule)
                                          }
                                          <div className="grey-blk">{last?.schedule?.team2_score || (last?.schedule?.team1_score ? 0 : '')}</div>
                                        </div>
                                      </div>
                                      <div className="team-name">
                                        <span>{last?.name} - {last?.field_id ? fieldName(last?.field_id) : TBD.name} - {locationName(last?.location_id)}</span>
                                      </div>
                                    </div>
                                  ))
                                }
                              </div>
                            ))
                          }
                        </div>
                    ))
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
      {
        errorMessage &&
        errorMessage !== '' &&
        <div className="playoff-bracket schedule-create-block">
          <div className="no-record">
            <h3>
              {errorMessage}
            </h3>
          </div>
        </div>
      }
    </>

  );
}

export default withRouter(TheoreticalPlayoffBracket);
